<div class="grid-container margin-top wrapper">
    <div class="grid-x grid-margin-x">
        <div class="cell large-12 medium-12 small-12 text-align-center bold">
            <h3 class="h4">Document Scanning Request</h3>
        </div>
        <div class="cell large-12 medium-12 small-12">
            <document-scanning-request (cancelRequest)="cancel()" [isAdhoc]="true" (requestSubmitted)="requestsCreated($event)" (throwError)="handleError($event)"></document-scanning-request>
        </div>
    </div>
</div>
<a style="display: none;" href="" target="_blank" #download>Download</a>